export const RoutePaths = () => {
  const baseUrl = '';
  const rootPaths = {
    login: baseUrl + '/login',
    logout: baseUrl + '/logout',
    error: baseUrl + '/error',
  };
  return {
    root: () => '/',
    login: {
      login: () => rootPaths.login,
      resetRequired: () => `${rootPaths.login}/require-reset`,
      forgotPassword: () => `${rootPaths.login}/forgot-password`,
      resetPassword: () => `${rootPaths.login}/reset-password`,
      verify: () => `${rootPaths.login}/verify`,
    },
    logout: {
      logout: () => rootPaths.logout,
    },
    error: {
      error: () => rootPaths.error,
    },
  };
};
